import { useEffect } from 'react'

import { useRouter } from 'next/router'

import { useGetFlowData } from '@twisto/flow-views'
import { useGoBack } from '@twisto/flow-views/components/flow-hooks'

export const useFlowBrowserEvent = () => {
  const { query } = useRouter()
  const sessionId = query.sessionId as string

  const { flow } = useGetFlowData(sessionId)

  const canGoBack = flow?.canGoBack

  const goBack = useGoBack(sessionId)

  const onBackButtonEvent = async (e: PopStateEvent) => {
    e.preventDefault()
    if (canGoBack === true) {
      await goBack()
    } else {
      window.history.back()
    }

    return false
  }

  useEffect(() => {
    window.addEventListener('popstate', onBackButtonEvent)

    return () => {
      window.removeEventListener('popstate', onBackButtonEvent)
    }
  })
}
